const types = {
	//Get Template name
	GET_VENDOR_EVALUATION_START: "GET_VENDOR_EVALUATION_START",
	GET_VENDOR_EVALUATION_SUCCESS: "GET_VENDOR_EVALUATION_SUCCESS",
	GET_VENDOR_EVALUATION_ERROR: "GET_VENDOR_EVALUATION_ERROR",
	GET_VENDOR_EVALUATION_RESET: "GET_VENDOR_EVALUATION_RESET",

	//Create Template name
	CREATE_VENDOR_EVALUATION_START: "CREATE_VENDOR_EVALUATION_START",
	CREATE_VENDOR_EVALUATION_SUCCESS: "CREATE_VENDOR_EVALUATION_SUCCESS",
	CREATE_VENDOR_EVALUATION_ERROR: "CREATE_VENDOR_EVALUATION_ERROR",
	CREATE_VENDOR_EVALUATION_RESET: "CREATE_VENDOR_EVALUATION_RESET",

	//delete Template name
	DELETE_VENDOR_EVALUATION_START: "DELETE_VENDOR_EVALUATION_START",
	DELETE_VENDOR_EVALUATION_SUCCESS: "DELETE_VENDOR_EVALUATION_SUCCESS",
	DELETE_VENDOR_EVALUATION_ERROR: "DELETE_VENDOR_EVALUATION_ERROR",
	DELETE_VENDOR_EVALUATION_RESET: "DELETE_VENDOR_EVALUATION_RESET",

	//update Template name
	UPDATE_VENDOR_EVALUATION_START: "UPDATE_VENDOR_EVALUATION_START",
	UPDATE_VENDOR_EVALUATION_SUCCESS: "UPDATE_VENDOR_EVALUATION_SUCCESS",
	UPDATE_VENDOR_EVALUATION_ERROR: "UPDATE_VENDOR_EVALUATION_ERROR",
	UPDATE_VENDOR_EVALUATION_RESET: "UPDATE_VENDOR_EVALUATION_RESET",

	//single item  name
	SINGLE_VENDOR_EVALUATION_START: "SINGLE_VENDOR_EVALUATION_START",
	SINGLE_VENDOR_EVALUATION_SUCCESS: "SINGLE_VENDOR_EVALUATION_SUCCESS",
	SINGLE_VENDOR_EVALUATION_ERROR: "SINGLE_VENDOR_EVALUATION_ERROR",
	SINGLE_VENDOR_EVALUATION_RESET: "SINGLE_VENDOR_EVALUATION_RESET",
};

export default types;
